import cookie from "js-cookie";
import {
    Configuration,
    AnalyticsApi as _AnalyticsApi,
    AccountsApi as _AccountsApi,
    AdminApi as _AdminApi,
    AuthApi as _AuthApi,
    DatauploadApi as _DatauploadApi,
    DatadownloadsApi as _DatadownloadsApi,
    EmissionRecordsApi as _EmissionRecordsApi,
    EpaSepApi as _EpaSepApi,
    InfrastructureApi as _InfrastructureApi,
    NondetectsApi as _NondetectsApi,
    MapApi as _MapApi,
    EmissioneventsApi as _EmissioneventsApi,
    DataProvidersApi as _DataProvidersApi,
    DataImportApi as _DataImportApi,
    NotificationsApi as _NotificationsApi,
    DataPointsApi as _DataPointsApi,
    GeodataApi as _GeodataApi,
    SensorDataApi as _SensorDataApi,
    UnmatchedDataApi as _UnmatchedDataApi,
    UserGuideApi as _UserGuideApi,
    EventFormsApi as _EventFormsApi,
    FormsApi as _FormsApi,
    WorkflowsApi as _WorkflowsApi,
} from "./generated";
import { BACKEND_URL } from "../constants/globals";
import { ROUTES } from "../routes";

// The session check endpoints. Their callers (AuthProvider, the login pages)
// handle a 401 themselves with a client-side redirect; doing a hard redirect
// here as well reloads the page and flashes the login form twice.
const SESSION_CHECK_PATHS = [
    "/api/v1/accounts/membership/my/",
    "/api/v1/accounts/companies/my/",
];

const getApiConfig = () => {
    const config = {
        basePath: BACKEND_URL,
        apiKey: undefined,
        credentials: "include" as RequestCredentials,
        // Using middleware to intercept 401 responses and redirect to login page.
        middleware: [
            {
                pre: async (context) => {
                    const { url, init } = context;
                    if (
                        ["DELETE", "PATCH", "POST", "PUT"].includes(init.method)
                    ) {
                        const headers = new Headers(init.headers);
                        headers.set("X-CSRFToken", cookie.get("csrftoken"));
                        return {
                            url,
                            init: {
                                ...init,
                                headers,
                            },
                        };
                    }
                },
            },
            {
                post: async (context) => {
                    if (
                        context.response.status === 401 &&
                        !window.location.pathname.includes("/login") &&
                        !SESSION_CHECK_PATHS.includes(
                            new URL(context.url, window.location.origin)
                                .pathname,
                        )
                    ) {
                        const pathWithQueryAndHash =
                            window.location.pathname +
                            window.location.search +
                            window.location.hash;
                        // Redirect to the login page with the 'next' parameter set to the current URL
                        window.location.href = `/login?next=${encodeURIComponent(
                            pathWithQueryAndHash,
                        )}`;
                    }
                },
            },
            // Using middleware to intercept 403 responses caused by ip not whitelisted and
            // redirect to ip not whitelisted page.
            {
                post: async (context) => {
                    if (
                        context.response.status === 403 &&
                        !window.location.pathname.includes(
                            ROUTES.IP_NOT_WHITELISTED,
                        )
                    ) {
                        const text = await context.response.text();
                        if (
                            text ===
                            "Access denied: Your IP is not whitelisted."
                        ) {
                            window.location.href = ROUTES.IP_NOT_WHITELISTED;
                        }
                    }
                },
            },
        ],
    };

    return new Configuration(config);
};

export const AnalyticsApi = () => {
    return new _AnalyticsApi(getApiConfig());
};

export const AccountsApi = () => {
    return new _AccountsApi(getApiConfig());
};

export const AuthApi = () => {
    return new _AuthApi(getApiConfig());
};

export const DatauploadApi = () => {
    return new _DatauploadApi(getApiConfig());
};

export const DatadownloadsApi = () => {
    return new _DatadownloadsApi(getApiConfig());
};

export const EmissionRecordsApi = () => {
    return new _EmissionRecordsApi(getApiConfig());
};

export const InfrastructureApi = () => {
    return new _InfrastructureApi(getApiConfig());
};

export const NondetectsApi = () => {
    return new _NondetectsApi(getApiConfig());
};

export const MapApi = () => {
    return new _MapApi(getApiConfig());
};

export const EmissionEventsApi = () => {
    return new _EmissioneventsApi(getApiConfig());
};

export const EpaSepApi = () => {
    return new _EpaSepApi(getApiConfig());
};

export const DataProvidersApi = () => {
    return new _DataProvidersApi(getApiConfig());
};

export const DataImportApi = () => {
    return new _DataImportApi(getApiConfig());
};

export const NotificationsApi = () => {
    return new _NotificationsApi(getApiConfig());
};

export const DataPointsApi = () => {
    return new _DataPointsApi(getApiConfig());
};

export const AdminApi = () => {
    return new _AdminApi(getApiConfig());
};

export const GeodataApi = () => {
    return new _GeodataApi(getApiConfig());
};

export const SensorDataApi = () => {
    return new _SensorDataApi(getApiConfig());
};

export const UserGuideApi = () => {
    return new _UserGuideApi(getApiConfig());
};

export const EventFormsApi = () => {
    return new _EventFormsApi(getApiConfig());
};

export const FormsApi = () => {
    return new _FormsApi(getApiConfig());
};

export const WorkflowsApi = () => {
    return new _WorkflowsApi(getApiConfig());
};

export const UnmatchedDataApi = () => {
    return new _UnmatchedDataApi(getApiConfig());
};
